<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h4 class="cardD">Cita para firma</h4>

    <div>
      <!-- <ValidationProvider
        name="link_cita"
        rules="required"
        v-slot="{ errors }"
        :custom-messages="{ required: 'El link es obligatorio' }"
      > -->
      <b-form-group label="Link cita Calendly" label-for="input-link-cita">
        <b-input-group class="mt-3">
          <b-input-group-append>
            <b-button
              :variant="isTextCopied ? 'success' : 'secondary'"
              squared
              v-b-tooltip.hover
              title="Copiar"
              @click="copyLinkToClipboard"
            >
              <b-icon v-if="isTextCopied" icon="check"></b-icon>
              <b-icon v-else icon="clipboard"></b-icon>
            </b-button>
          </b-input-group-append>
          <b-form-input
            id="input-link-cita"
            type="url"
            v-model="cita.link_calendario"
            placeholder="Link Calendly"
          ></b-form-input>
        </b-input-group>
      </b-form-group>

      <!-- <base-input type="text" label="Link cita Calendly" placeholder="Link Calendly"
          v-model="constitutiva.link_calendario">
        </base-input> -->

      <!-- <span class="cardErrors">{{ errors[0] }}</span>
      </ValidationProvider> -->
    </div>

    <!-- <div v-if="!constitutiva.firma_oficina" class="mt-3">
      <ValidationProvider name="direccion_firma" rules="required" v-slot="{ errors }" :custom-messages="{
        required: 'La dirección es obligatoria'
      }">
        <base-input type="text" label="Dirección" placeholder="Dirección donde será la firma"
          v-model="constitutiva.direccion_firma">
        </base-input>
        <span class="cardErrors">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <div class="row mt-4 fecha">
      <div class="col-3">
        <label class="">Fecha seleccionada</label>
      </div>
      <div class="col-9">
        {{ fecha_formatted }}
      </div>
    </div> -->

    <div class="row mt-3">
      <div class="col-md-3">
        <b-form-group label="Fecha de la cita" label-for="input-cita-fecha-cita">
          <b-form-input id="input-cita-fecha-cita" type="date" v-model="cita.fecha_cita" :disabled="false"></b-form-input>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group label="Hora de la cita" label-for="input-cita-hora-cita">
          <b-form-input id="input-cita-hora-cita" type="time" v-model="cita.hora_cita" :disabled="false"></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <b-form-group label="Modificaciones" label-for="input-cita-modificaciones">
          <b-form-textarea id="input-cita-modificaciones" v-model="cita.modificaciones" :disabled="false"></b-form-textarea>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <b-form-group label="La firma se llevó a cabo" label-for="input-cita-firam-realizada">
          <b-form-checkbox id="input-cita-firam-realizada" v-model="cita.firma_realizada" :disabled="false"></b-form-checkbox>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <b-form-group label="Observaciones" label-for="input-cita-observaciones">
          <b-form-textarea id="input-cita-observaciones" v-model="cita.observaciones" :disabled="false"></b-form-textarea>
        </b-form-group>
      </div>
    </div>

    <div class="mt-4">
      <div class="">
        <!-- <b-button type="submit" class="btn-fill orange-btn bottom2" size="m">Enviar mail al cliente</b-button> -->
        <b-button class="btn-fill orange-btn bottom2" size="m" @click="guardarHandler()">Guardar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { CitasApi } from "@/api";

export default {
  name: "TabCitaFirma",

  props: {
    constitutiva: { type: Object },
  },

  created() {
    // if (this.constitutiva.fecha_firma) {
    //   const date = new Date(this.constitutiva.fecha_firma);
    //   const hour = this.constitutiva.fecha_firma.substring(11, 16);

    //   this.fecha_formatted = date.toLocaleDateString();
    //   this.fecha_formatted += " ";
    //   this.fecha_formatted += hour;
    // }

    try {
      this.fetchCita();
    } catch (error) {}
  },

  data: () => ({
    loading: false,
    isTextCopied: false,
    fecha_formatted: null,

    existingAppointment: false,

    cita: {
      id: null,
      creado: null,
      actualizado: null,
      activo: null,

      cat_servicio_id: null,
      proceso_id: null,

      link_calendario: null,
      fecha_cita: null,
      hora_cita: null,
      modificaciones: null,
      firma_realizada: null,
      observaciones: null,
    },
  }),

  methods: {
    async fetchCita() {
      try {
        this.loading = true;

        const { value } = await CitasApi.list({
          page: 0,
          registersPerPage: 0,
          cat_servicio_id: 1,
          proceso_id: this.constitutiva.id,
        });

        if (value.length !== 0) {
          const cita = value[0];

          this.cita.id = cita.id;
          this.cita.creado = cita.creado;
          this.cita.actualizado = cita.actualizado;
          this.cita.activo = cita.activo;

          this.cita.cat_servicio_id = 1;
          this.cita.proceso_id = cita.proceso_id;

          this.cita.link_calendario = cita.link_calendario;
          this.cita.fecha_cita = cita.fecha_cita;
          this.cita.hora_cita = cita.hora_cita;
          this.cita.modificaciones = cita.modificaciones;
          this.cita.firma_realizada = cita.firma_realizada;
          this.cita.observaciones = cita.observaciones;

          this.existingAppointment = true;
        } else {
          this.cita.cat_servicio_id = 1;
          this.cita.proceso_id = this.constitutiva.id;
          this.existingAppointment = false;
        }

        this.$toast.success("Información cargada.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return true;
      } catch (error) {
        console.log(error);
        this.$toast.error("Ocurrió un error al cargar la información.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        return false;
      } finally {
        this.loading = false;
      }
    },

    async saveCita() {
      try {
        this.loading = true;

        const _cita = Object.assign({}, this.cita);

        if (this.existingAppointment) {
          delete _cita.creado;
          delete _cita.actualizado;

          const cita = await CitasApi.edit(this.cita.id, _cita);
        } else {
          delete _cita.id;
          delete _cita.creado;
          delete _cita.activo;
          delete _cita.actualizado;

          const cita = await CitasApi.create(_cita);
        }

        return true;
      } catch (error) {
        console.log(error);
        this.$toast.error("Ocurrió un error al guardar la información.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        return false;
      } finally {
        this.loading = false;
      }
    },

    guardarHandler() {
      this.saveCita().then((result) => {
        if (result) {
          this.$toast.success("Información guardada.", {
            timeout: 4000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          });
          this.submitSaveConstitucion();
        }
      });
    },

    validar() {
      this.$emit("validaForm", "CitaFirma");
    },

    submitSaveConstitucion() {
      this.$emit("saveConstitucion");
    },

    copyLinkToClipboard() {
      if (!this.constitutiva.link_calendario) {
        return;
      }

      navigator.clipboard.writeText(this.constitutiva.link_calendario).then((this.isTextCopied = true));
    },
  },
};
</script>

<style scoped>
.fecha {
  margin-top: 60px !important;
}
</style>
